import { Component } from 'react';
import { withTranslation } from '../../lib/translate.js';
import { SmallText } from '../common/index.js';
import { forwardTo } from '../../lib/utils.js';
import { getNavigationItems } from './items.js';
import './index.css';

class BottomNavigationAndroid extends Component {
  render() {
    const { __ } = this.props;
    return (
      <div className="bottom-navigation-wrapper navigation-android">
        {getNavigationItems(__).map((item) => {
          const active = location.pathname === item.url;
          return (
            <div key={item.url} className={active ? 'navigation-active' : ''} onClick={() => forwardTo(item.url, item.params)}>
              {active && item.iconActive ? item.iconActive : item.icon}
              <SmallText>{item.text}</SmallText>
            </div>
          );
        })}
      </div>
    );
  }
}

export default withTranslation(BottomNavigationAndroid);
